import React from "react";
import { useSelector } from "react-redux";
import { cafeSelector, stationListSelector } from "../../selectors/diningSelector";
import styles from "../../styles/stationImageList.module.css";
import withAppInsights from "../AppInsights/AppInsights";
import StationImageCard from "./StationImageCard";

const StationImageList = () => {
  const stations = useSelector(stationListSelector);
  const selectedCafe = useSelector(cafeSelector);

  return (
    <div className={styles.stationImages}>
      <h1 className={styles.stationImagesContainer}>Station Images</h1>
      <div className={styles.cardListContainer}>
        <ul className={styles.cardList}>
          {stations.map((station) => {
            return (
              <li key={station.id}>
                <StationImageCard
                  cafeId={selectedCafe?.id || ""}
                  stationId={station.id}
                  name={station.name}
                  imageUrl={station.imageUrl}
                />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default withAppInsights(StationImageList);
